// extracted by mini-css-extract-plugin
module.exports = {"articleCountContainer":"Styles_articleCountContainer__1lBCV","text":"Styles_text__KENN2","closeIcon":"Styles_closeIcon__2MqkU","limitReached":"Styles_limitReached__GjONu"};